/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashledger_My_Title1Inputs */

const vi_cashledger_my_title1 = /** @type {(inputs: Cashledger_My_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quỹ tiền mặt của tôi`)
};

/**

* @param {Cashledger_My_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cashledger_my_title1 = /** @type {((inputs?: Cashledger_My_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashledger_My_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashledger_my_title1(inputs)
});
export { cashledger_my_title1 as "cashLedger_my_title" }